import { sidebarStyles } from '../../Editor'

export const { container, label, field, description, title } = sidebarStyles
